import { create } from 'zustand';

export type ThemeMode = 'light' | 'dark' | 'system';
const KEY = 'tcrd.theme';

function read(): ThemeMode {
  try {
    const v = localStorage.getItem(KEY);
    // Por defecto: claro (el usuario puede elegir oscuro o el del sistema en Perfil → Apariencia).
    return v === 'light' || v === 'dark' || v === 'system' ? v : 'light';
  } catch {
    return 'light';
  }
}

const media = typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null;

function apply(mode: ThemeMode) {
  const dark = mode === 'dark' || (mode === 'system' && !!media?.matches);
  const root = document.documentElement;
  root.classList.toggle('dark', dark);
  root.classList.toggle('ion-palette-dark', dark);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#111111' : '#ffffff');
}

export const useTheme = create<{ mode: ThemeMode; setMode(m: ThemeMode): void }>((set) => ({
  mode: read(),
  setMode(mode) {
    try {
      localStorage.setItem(KEY, mode);
    } catch {
      /* almacenamiento no disponible */
    }
    apply(mode);
    set({ mode });
  },
}));

export function initTheme() {
  apply(read());
  media?.addEventListener('change', () => apply(useTheme.getState().mode));
}
